import React from "react";
import {Dropdown} from "semantic-ui-react";
import {Dialog} from "../../../Dialogs/Dialog";
import Button from "../../../Button";
import {ISelectFieldValue} from "../../VirtualizedTableInterfaces";

interface MultiSelectDialogProps {
    open: boolean;
    title: string;
    dialogText: string;
    cellKey: string;
    value: ISelectFieldValue;
    onChange: (value: any) => void;
    onClose: () => void;
    customStyle ?: {[key: string]: string};
}

interface MultiSelectDialogState {
    selectedItems: any;
}

export default class MultiSelectDialog extends React.Component<MultiSelectDialogProps, MultiSelectDialogState> {
    constructor(props: MultiSelectDialogProps) {
        super(props);

        this.state = {
            selectedItems: this.props.value.value ? this.props.value.value : []
        };
    }

    private handleSubmit = () => {
        if (!this.props.open || !this.props.onChange) {
            return;
        }

        this.props.onChange(this.state.selectedItems);
    }

    public render() {
        const payload: ISelectFieldValue = this.props.value;
        if (!payload || !payload.options || payload.options.length === 0)
            return null;

        return (
            <Dialog
                open={this.props.open}
                title={this.props.title}
                actions={[
                    <Button
                        key={"submitButton"}
                        icon={"checkmark"}
                        onClick={this.handleSubmit}
                    />,
                    <Button
                        key={"cancelButton"}
                        icon={"ban"}
                        onClick={this.props.onClose}
                    />
                ]}
            >

                <p>{this.props.dialogText}</p>

                <Dropdown
                    multiple={true}
                    search={true}
                    disabled={!this.props.open}
                    fluid={true}
                    selection={true}
                    value={this.state.selectedItems}
                    options={payload.options}
                    onChange={(e, v) => this.setState({selectedItems: v.value})}
                    style={this.props.customStyle ? this.props.customStyle: {}}
                />
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Table/components/modalDropdown/MultiSelectDialog.tsx